import { FolderOpen, Wallet, MoreVertical } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia } from "../../services/api";
import { useState, useRef, useEffect } from "react";

export default function ClientRow({ client, onView,onWalletAction }) {
  const user = client.user;
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);

  const avatar = resolveMedia(user?.profilPicture, defaultAvatar);
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <tr>
      {/* CLIENT */}
      <td>
        <div className="userCell">
          <img src={avatar} alt="avatar" className="tableAvatar" />
          <div>
            <div className="userName">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="userSub">{user?.username}</div>
          </div>
        </div>
      </td>

      {/* TELEPHONE */}
      <td>{user?.contact?.tel || "-"}</td>

      {/* SOLDE */}
      <td>
        <span className="roleBadge">
          {(client.balance ?? 0).toLocaleString()} CFA
        </span>
      </td>

      <td className="center">
        <div className="actionsMenu" ref={menuRef}>
          <button className="iconBtn" onClick={() => setOpen(!open)}>
            <MoreVertical size={18} />
          </button>

          {open && (
            <div className="dropdownActions">
              <button onClick={() => onView?.(client)}>
                <FolderOpen size={16} /> Détails
              </button>

              <button
                onClick={() => {
                  setOpen(false);
                  onWalletAction(client, "increase");
                }}
              >
                <Wallet size={16} className="text-success" /> Recharger compte
              </button>

              <button
                onClick={() => {
                  setOpen(false);
                  onWalletAction(client, "decrease");
                }}
              >
                <Wallet size={16} className="text-danger" /> Retirer solde
              </button>
            </div>
          )}
        </div>
      </td>
    </tr>
  );
}
